module.exports = "https://r.zoocdn.com/_next/static/images/selected-sold-property-pin-423542eecbc5759f2329d4d454e9f647.svg";